export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/beauty_fashion.6bf019b.svg";